import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SmsMessagesListComponent } from './sms-messages-list/sms-messages-list.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: SmsMessagesListComponent,
        data: {
          title: 'Sms Messages'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SmsMessagesRoutingModule {
}
